import React, {useEffect, useRef, useState} from "react";
import { mrbgStore, redFldToWhite, setSundryField } from './mrbgRedux/index.js';
import {mrbgTools} from "../../mrbgLib/mrbgTools.js";

function MrbgNormalInput({formID,type,name,other,fldAttr,relativePath,storeInRedux,formStyle}){

  const
    refInp = useRef(),
    [inpType,setInpType] = useState(type),
    [inpVal ,setInpVal ] = useState(''),
    [micCls,setMicCls] = useState(`${formStyle.mrbgMicro} fa-solid fa-microphone-slash`),
    [eyeCls,setEyeCls] = useState(`${formStyle.passEye} fa-solid fa-eye-slash`),
    [formsSettings,setFormsSettings] = useState( mrbgStore.getState().formsSettings[formID] ),
    inputMode = ['email','search','tel','url'];

  function changeInpVal(e){
    var val = e.target.value;
    if( val!==inpVal )
      setInpVal(val);
    if( val!=='' && formsSettings.redFld.includes(name) )
      mrbgStore.dispatch(redFldToWhite({formID,name}));
    if( relativePath ){
      var path =
        ['home','house','بیت','خانه','صفحه اصلی',mrbgStore.getState().enTitle,mrbgStore.getState().faTitle].includes( val.toLocaleLowerCase() )?
          '/':
          '/'+val.replaceAll(/(^|\s)((از|با|به|تا|در|را|یا)\s?)+(\s|$)/g,' ').trim().replaceAll(/\s+/g,'-');
      mrbgTools.triggerChange(document.querySelector(`[data-id="${formID}"] input[name="${relativePath}"]`),path)
    }
    if( other.onChange ){
      other.onChange(e)
    }
  }
  function changeInpType(){
    if( inpType=='password' ){
      setInpType('text');
      setEyeCls(formStyle.passEye+' fa-solid fa-eye')
    }
    else{
      setInpType('password');
      setEyeCls(formStyle.passEye+' fa-solid fa-eye-slash')
    }
  }
  function listening(){
    if( mrbgTools.recog.listening ){
      mrbgTools.recog.stop()
      setMicCls(`${formStyle.mrbgMicro} fa-solid fa-microphone-slash`);
    }
    else if( micCls===`${formStyle.mrbgMicro} fa-solid fa-microphone ${formStyle.activeMrbgMicro}` ){
      setMicCls(`${formStyle.mrbgMicro} fa-solid fa-microphone-slash`);
    }
    else{
      mrbgTools.recog.start();
      mrbgTools.recog.mrbgTI=refInp.current;
      setMicCls(`${formStyle.mrbgMicro} fa-solid fa-microphone ${formStyle.activeMrbgMicro}`);
    }
  }

  useEffect( () => {
    if( storeInRedux )
      mrbgStore.dispatch( setSundryField({formID,fieldName:name,fieldValue:inpVal}) )
  }, [inpVal] );
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setFormsSettings(mrbgStore.getState().formsSettings[formID])
    })
    return () =>unsubscribe();
  },[]);

  return(
    <>
      <input name={name} type={inpType} value={inpVal} inputMode={inputMode.includes(inpType)? inpType:'text'} className={formsSettings?.redFld.includes(name)? formStyle.emptyField: ''} disabled={formsSettings?.disabled?.includes(name)? true:false} autoComplete={type=='password'? "off": "on"} {...other} ref={refInp} onChange={e=>changeInpVal(e)}/>
      {fldAttr?.className?.includes('mrbgVoice'   )? <i className={micCls} onClick={()=>listening()}></i>:''}
      {fldAttr?.className?.includes('mrgbViewPass')? <i className={eyeCls} onClick={()=>changeInpType()}></i>:''}
    </>
  )
}

export default MrbgNormalInput;